import {Component, OnInit} from 'angular2/core';
import {CampaignService} from "../campaign.service";
import {RouteParams, Router} from "angular2/router";
import {AlertService} from "../../common/alerts/alert.service";
import {TranslateService, TranslatePipe} from "ng2-translate";
import {Campaign} from "../../../models/campaign.model";
import {DatePipe} from "angular2/common";
import {ProductService} from "../../products/product.service";

@Component({
    templateUrl: './app/components/campaigns/show/show.html',
    providers: [CampaignService, ProductService],
    pipes: [TranslatePipe, DatePipe]
})
export class ShowCampaignComponent implements OnInit {
    campaign:Campaign;
    products:string[];

    constructor(private _alert_service:AlertService, private _router:Router, private _productService:ProductService,
                private _translateService:TranslateService, private _params:RouteParams, private _campaignService:CampaignService) {
        this.campaign = new Campaign({});
    }

    ngOnInit() {
        this._campaignService.getCampaign(this._params.get("campaignId")).subscribe(campaign => {
            this.campaign = campaign;
            if (this.campaign.products != null) {
                this._productService.getProductsByIds(this.campaign.country, this.campaign.products)
                    .subscribe(products => this.products = products);
            } else {
                this.products = [];
            }

        });

    }

    downloadCsvLink(id) {
        this._campaignService.getDownloadCsv(id).subscribe(void {});
    }

    destroyCampaign(id:string) {
        let result = confirm(this._translateService.instant('campaigns.delete.confirm'));
        if (result) {
            this._campaignService.destroyCampaign(id).subscribe(a => {
                    this._router.navigate(['Campaigns']);
                    this._alert_service.pushAlert({
                        type: "success",
                        msg: this._translateService.instant("campaigns.delete.success"),
                        closeable: true
                    });
                },
                error => this._alert_service.pushAlert({
                    type: "danger",
                    msg: this._translateService.instant(error),
                    closeable: true
                })
            );
        }
    }
}
